import { useState } from "react";

const CSS = `
.bc1{--bg:#0A0E14;--pan:#111823;--pan2:#0D141D;--ln:#1E2A38;--ink:#DEE7F1;--dim:#8195AB;--fnt:#5A6B7F;
--sig:#F0A21C;--cool:#4FB6F5;--ok:#3DD68C;--bad:#FF6B6B;--vio:#A78BFA;
--m:ui-monospace,"JetBrains Mono",SFMono-Regular,Menlo,Consolas,monospace;
--s:"Inter",ui-sans-serif,system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;
background:var(--bg);color:var(--ink);font-family:var(--s);line-height:1.65;
-webkit-font-smoothing:antialiased;border:1px solid var(--ln);border-radius:14px;overflow:hidden}
.bc1 *,.bc1 *::before,.bc1 *::after{box-sizing:border-box}
.bc1 h1,.bc1 h2,.bc1 h3,.bc1 h4{margin:0;font-weight:600;letter-spacing:-.01em}
.bc1 code{font-family:var(--m);font-size:.86em}
.bc1 button:focus-visible{outline:2px solid var(--sig);outline-offset:2px}
.bc1 b{color:var(--ink)}
.bc1 .p{max-width:74ch;color:var(--dim);margin:0 0 16px}
.bc1 .mono{font-family:var(--m);font-size:10px;letter-spacing:.14em;text-transform:uppercase}
.bc1 .hero{padding:44px 34px 32px;border-bottom:1px solid var(--ln);
background:radial-gradient(900px 300px at 8% -30%,rgba(240,162,28,.13),transparent 70%),
radial-gradient(700px 320px at 92% -10%,rgba(79,182,245,.1),transparent 70%),var(--pan2)}
.bc1 .hero .mono{color:var(--sig);margin-bottom:16px}
.bc1 .hero h1{font-size:clamp(30px,5.5vw,54px);line-height:1.05;letter-spacing:-.03em}
.bc1 .hero h1 i{font-style:normal;color:var(--fnt);font-weight:300;margin:0 12px}
.bc1 .hero h1 em{font-style:normal;color:var(--sig)}
.bc1 .lede{max-width:66ch;color:var(--dim);font-size:16.5px;margin:18px 0 24px}
.bc1 .stats{display:flex;flex-wrap:wrap;gap:30px;margin-top:24px;padding-top:20px;border-top:1px solid var(--ln)}
.bc1 .stats b{display:block;font-family:var(--m);font-size:26px;color:var(--cool)}
.bc1 .stats span{font-size:12px;color:var(--fnt)}
.bc1 .fine{font-size:12px;color:var(--fnt);margin:14px 0 0;max-width:62ch}
.bc1 .tabs{display:flex;gap:2px;overflow-x:auto;padding:0 20px;background:var(--pan2);
border-bottom:1px solid var(--ln);position:sticky;top:0;z-index:5}
.bc1 .tabs button{flex:0 0 auto;background:none;border:0;border-bottom:2px solid transparent;
color:var(--fnt);font-family:var(--m);font-size:12px;padding:15px 13px;cursor:pointer;white-space:nowrap}
.bc1 .tabs button:hover{color:var(--dim)}
.bc1 .tabs button.on{color:var(--sig);border-bottom-color:var(--sig)}
.bc1 .body{padding:32px 34px}
.bc1 .hd{display:flex;gap:15px;align-items:flex-start;margin:36px 0 16px}
.bc1 .hd:first-child{margin-top:0}
.bc1 .hd .step{font-family:var(--m);font-size:10px;letter-spacing:.15em;text-transform:uppercase;
color:var(--bg);background:var(--sig);padding:5px 9px;border-radius:4px;margin-top:6px;white-space:nowrap;font-weight:700}
.bc1 .hd h2{font-size:22px}
.bc1 .hd p{color:var(--fnt);font-size:14px;margin:5px 0 0;max-width:72ch}
.bc1 pre.ascii{font-family:var(--m);font-size:12.5px;line-height:1.55;color:var(--cool);
background:var(--pan2);border:1px solid var(--ln);border-left:3px solid var(--cool);
border-radius:8px;padding:18px 20px;overflow-x:auto;margin:18px 0;white-space:pre}
.bc1 pre.sh{font-family:var(--m);font-size:12.5px;line-height:1.6;background:#070B10;
border:1px solid var(--ln);border-radius:8px;padding:14px 16px;overflow-x:auto;
color:var(--ok);margin:0 0 12px;white-space:pre}
.bc1 .co{border:1px solid var(--ln);border-left:3px solid var(--dim);border-radius:10px;
padding:16px 18px;margin:20px 0;background:var(--pan)}
.bc1 .co.key{border-left-color:var(--sig)}
.bc1 .co.trap{border-left-color:var(--bad)}
.bc1 .co.note{border-left-color:var(--cool)}
.bc1 .co h5{margin:0 0 8px;font-family:var(--m);font-size:11px;letter-spacing:.12em;
text-transform:uppercase;color:var(--dim);font-weight:600}
.bc1 .co.key h5{color:var(--sig)}
.bc1 .co.trap h5{color:var(--bad)}
.bc1 .co.note h5{color:var(--cool)}
.bc1 .co div{color:var(--dim);font-size:14.5px}
.bc1 .co ul{margin:8px 0 0;padding-left:18px}
.bc1 .co li{margin-bottom:7px}
.bc1 .grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(255px,1fr));gap:14px;margin:18px 0}
.bc1 .card{background:var(--pan);border:1px solid var(--ln);border-radius:10px;padding:17px}
.bc1 .card h4{font-size:14.5px;color:var(--sig);margin-bottom:8px}
.bc1 .card p{font-size:13.5px;color:var(--dim);margin:0 0 9px}
.bc1 .card ul{margin:0;padding-left:16px}
.bc1 .card li{font-size:13px;color:var(--dim);margin-bottom:6px}
.bc1 .card .sub{font-size:12px;color:var(--fnt);margin:-4px 0 10px}
.bc1 .card .foot{font-size:12.5px;color:var(--dim);border-top:1px dashed var(--ln);padding-top:9px;margin:0 0 9px}
.bc1 .card .foot span{display:block;font-family:var(--m);font-size:9.5px;letter-spacing:.13em;
text-transform:uppercase;color:var(--fnt);margin-bottom:3px}
.bc1 .card.cool h4{color:var(--cool)}
.bc1 .exp{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:16px;margin:22px 0}
.bc1 .exp>div{background:var(--pan);border:1px solid var(--ln);border-radius:12px;padding:16px}
.bc1 .exp .lbl{font-family:var(--m);font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:var(--sig)}
.bc1 .exp .hint{font-size:12.5px;color:var(--fnt);margin:6px 0 14px}
.bc1 .node{display:block;width:100%;text-align:left;background:var(--pan2);border:1px solid var(--ln);
border-radius:8px;padding:11px 13px;margin-bottom:8px;cursor:pointer;color:var(--dim)}
.bc1 .node:hover{border-color:var(--fnt)}
.bc1 .node.on{border-color:var(--sig);background:rgba(240,162,28,.09)}
.bc1 .node .c{display:block;font-family:var(--m);font-size:13px;color:var(--ink)}
.bc1 .node.on .c{color:var(--sig)}
.bc1 .node .t{display:block;font-size:12px;color:var(--fnt);margin-top:3px}
.bc1 .node .t b{font-family:var(--m);color:var(--cool)}
.bc1 .flag{font-style:normal;font-family:var(--m);font-size:9.5px;letter-spacing:.1em;
text-transform:uppercase;color:var(--ok);border:1px solid currentColor;border-radius:3px;padding:1px 5px;margin-left:7px}
.bc1 .flag.w{color:var(--vio)}
.bc1 .micro{font-size:12px;color:var(--fnt);border-top:1px dashed var(--ln);padding-top:11px;margin-top:11px}
.bc1 .micro b{color:var(--cool)}
.bc1 .dcs{display:flex;gap:9px;flex-wrap:wrap}
.bc1 .dc{flex:1 1 62px;background:var(--pan2);border:1px solid var(--ln);border-radius:7px;padding:11px 8px;text-align:center}
.bc1 .dc i{display:block;height:5px;background:var(--fnt);border-radius:2px;margin-bottom:4px;opacity:.55}
.bc1 .dc span{font-family:var(--m);font-size:10px;color:var(--fnt)}
.bc1 .tw{overflow-x:auto;border:1px solid var(--ln);border-radius:10px;margin:18px 0}
.bc1 table{width:100%;border-collapse:collapse;font-size:13.5px;min-width:600px}
.bc1 th{text-align:left;background:var(--pan2);color:var(--fnt);font-family:var(--m);font-size:10.5px;
letter-spacing:.12em;text-transform:uppercase;padding:12px 14px;border-bottom:1px solid var(--ln)}
.bc1 td{padding:12px 14px;border-bottom:1px solid var(--ln);color:var(--dim);vertical-align:top}
.bc1 tr:last-child td{border-bottom:0}
.bc1 td.k{color:var(--ink);font-weight:500}
.bc1 .pill{font-family:var(--m);font-size:10px;letter-spacing:.1em;text-transform:uppercase;
padding:3px 8px;border-radius:4px;border:1px solid currentColor;white-space:nowrap}
.bc1 .pill.g{color:var(--vio)}.bc1 .pill.r{color:var(--cool)}.bc1 .pill.z{color:var(--sig)}
.bc1 .arn{background:var(--pan);border:1px solid var(--ln);border-left:3px solid var(--vio);
border-radius:9px;padding:14px 16px;margin-bottom:11px}
.bc1 .arn code{display:block;color:var(--vio);font-size:12.5px;margin-bottom:8px;word-break:break-all}
.bc1 .arn p{font-size:13.5px;color:var(--dim);margin:0}
.bc1 .lab{display:flex;gap:16px;background:var(--pan);border:1px solid var(--ln);
border-radius:10px;padding:18px;margin-bottom:14px}
.bc1 .lab .n{flex:0 0 30px;height:30px;border-radius:50%;background:var(--pan2);border:1px solid var(--sig);
color:var(--sig);font-family:var(--m);font-size:13px;display:flex;align-items:center;justify-content:center}
.bc1 .lab h4{font-size:14.5px;margin-bottom:10px}
.bc1 .lab p{font-size:13.5px;color:var(--dim);margin:0}
.bc1 .lab code{color:var(--ok)}
.bc1 .fail{background:var(--pan);border:1px solid var(--ln);border-radius:12px;padding:20px;margin-bottom:18px}
.bc1 .fail .no{font-family:var(--m);font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:var(--bad)}
.bc1 .fail h3{font-size:17px;margin:6px 0}
.bc1 .fail .ask{font-size:14.5px;color:var(--ink);font-weight:600;margin:14px 0}
.bc1 .fail ol{margin:16px 0 0;padding:14px 0 0 18px;border-top:1px solid var(--ln)}
.bc1 .fail li{font-size:13.5px;color:var(--dim);margin-bottom:11px}
.bc1 .btn{background:var(--pan2);border:1px solid var(--sig);color:var(--sig);font-family:var(--m);
font-size:12px;padding:9px 15px;border-radius:7px;cursor:pointer}
.bc1 .btn:hover{background:rgba(240,162,28,.1)}
.bc1 .btn.ghost{border-color:var(--ln);color:var(--fnt)}
.bc1 .score{display:flex;align-items:center;gap:18px;background:var(--pan);border:1px solid var(--ln);
border-radius:10px;padding:14px 18px;margin-bottom:20px}
.bc1 .score .n{font-family:var(--m);font-size:22px;color:var(--sig)}
.bc1 .score .l{font-size:11px;color:var(--fnt);margin-left:7px;letter-spacing:.1em;text-transform:uppercase}
.bc1 .score .bar{flex:1;height:5px;background:var(--pan2);border-radius:3px;overflow:hidden}
.bc1 .score .fill{height:100%;background:var(--sig)}
.bc1 .q{background:var(--pan);border:1px solid var(--ln);border-radius:12px;padding:20px;margin-bottom:16px}
.bc1 .q .no{font-family:var(--m);font-size:11px;color:var(--sig);letter-spacing:.1em}
.bc1 .q .txt{font-size:15px;color:var(--ink);margin:8px 0 16px}
.bc1 .opts{display:grid;gap:8px}
.bc1 .opt{display:flex;gap:12px;align-items:flex-start;text-align:left;width:100%;background:var(--pan2);
border:1px solid var(--ln);border-radius:8px;padding:12px 14px;color:var(--dim);font-size:13.8px;
cursor:pointer;font-family:var(--s);line-height:1.5}
.bc1 .opt:not(:disabled):hover{border-color:var(--fnt);color:var(--ink)}
.bc1 .opt .k{font-family:var(--m);font-size:11px;color:var(--fnt);border:1px solid var(--ln);
border-radius:4px;padding:1px 6px;flex:0 0 auto;margin-top:2px}
.bc1 .opt.right{border-color:var(--ok);color:var(--ink);background:rgba(61,214,140,.08)}
.bc1 .opt.right .k{color:var(--ok);border-color:var(--ok)}
.bc1 .opt.wrong{border-color:var(--bad);color:var(--ink);background:rgba(255,107,107,.08)}
.bc1 .opt.wrong .k{color:var(--bad);border-color:var(--bad)}
.bc1 .opt.dim{opacity:.45}
.bc1 .opt:disabled{cursor:default}
.bc1 .vd{margin-top:14px;padding:13px 15px;border-radius:8px;font-size:13.5px;color:var(--dim);
background:var(--pan2);border-left:3px solid var(--ok)}
.bc1 .vd.no{border-left-color:var(--bad)}
.bc1 .vd .w{margin-top:9px;padding-top:9px;border-top:1px dashed var(--ln)}
.bc1 ol.five li{color:var(--dim);font-size:14.5px;margin-bottom:11px;max-width:78ch}
.bc1 ol.rapid li{font-family:var(--m);font-size:13px;color:var(--cool);margin-bottom:11px}
.bc1 .task{background:var(--pan);border:1px solid var(--ln);border-left:3px solid var(--vio);
border-radius:10px;padding:18px;margin:14px 0}
.bc1 .task p{font-size:14px;color:var(--dim);margin:0 0 12px;max-width:78ch}
.bc1 .task p:last-child{margin-bottom:0}
.bc1 .prog{font-family:var(--m);font-size:13px;background:var(--pan2);border:1px solid var(--ln);
border-radius:10px;padding:16px 18px;margin:14px 0}
.bc1 .prog div{color:var(--fnt);margin-bottom:7px}
.bc1 .prog div.d{color:var(--ok)}
.bc1 .prog i{display:inline-block;width:22px;font-style:normal}
.bc1 .lvl{font-size:13.5px;color:var(--dim);max-width:78ch}
.bc1 .lvl b{color:var(--sig);font-family:var(--m);font-size:12.5px}
.bc1 .rule{font-family:var(--m);font-size:15px;color:var(--ink)}
.bc1 .ft{display:flex;justify-content:space-between;flex-wrap:wrap;gap:10px;padding:20px 34px;
border-top:1px solid var(--ln);background:var(--pan2);font-family:var(--m);font-size:11.5px;color:var(--fnt)}
.bc1 .ft b{color:var(--sig)}
@media(max-width:640px){.bc1 .hero{padding:32px 20px 26px}.bc1 .body{padding:24px 20px}
.bc1 .ft{padding:18px 20px}.bc1 .lab{flex-direction:column;gap:12px}}
@media(prefers-reduced-motion:reduce){.bc1 *{transition:none!important;animation:none!important}}
`;

const REGIONS = [
  { code: "ap-south-1", city: "Mumbai", home: true, azs: [["ap-south-1a", "aps1-az1", 3], ["ap-south-1b", "aps1-az2", 2], ["ap-south-1c", "aps1-az3", 2]] },
  { code: "ap-south-2", city: "Hyderabad", optIn: true, azs: [["ap-south-2a", "aps2-az1", 1], ["ap-south-2b", "aps2-az2", 1], ["ap-south-2c", "aps2-az3", 1]] },
  { code: "ap-southeast-1", city: "Singapore", azs: [["ap-southeast-1a", "apse1-az1", 2], ["ap-southeast-1b", "apse1-az2", 2], ["ap-southeast-1c", "apse1-az3", 2]] },
  { code: "us-east-1", city: "N. Virginia", azs: [["us-east-1a", "use1-az1", 4], ["us-east-1b", "use1-az2", 4], ["us-east-1c", "use1-az3", 3], ["us-east-1d", "use1-az4", 3]] },
];

const SCOPE = [
  ["g", "Global", "IAM users, roles, policies", "Created once, visible from every Region."],
  ["g", "Global", "Route 53 (DNS)", "One hosted zone answers queries worldwide."],
  ["g", "Global", "CloudFront", "Served from edge locations everywhere."],
  ["g", "Global", "Organizations, Billing", "Account-wide, not Region-bound."],
  ["r", "Regional", "VPC", "One Region, stretches across all AZs in it."],
  ["r", "Regional", "S3 bucket", "Name is globally unique; the objects sit in one Region."],
  ["r", "Regional", "DynamoDB table", "One Region. Cross-Region is opt-in (Global Tables)."],
  ["r", "Regional", "ALB / NLB", "One Region, spans the AZs you enable."],
  ["z", "Zonal", "EC2 instance", "Runs in exactly one AZ. That AZ fails, it fails."],
  ["z", "Zonal", "EBS volume", "Pinned to one AZ. Cannot attach across AZs."],
  ["z", "Zonal", "Subnet", "A subnet belongs to exactly one AZ. Always."],
  ["z", "Zonal", "NAT Gateway", "Created in one subnet, so it lives in one AZ."],
];

const VS = [
  ["What it is", "A geographic area with a cluster of AZs", "One or more data centres inside a Region"],
  ["Separation", "Hundreds to thousands of km", "Kilometres - same metro area"],
  ["Latency", "Tens to hundreds of ms", "Typically ~1-2 ms, single digit"],
  ["Protects from", "City / country-wide disaster", "Data centre failure - power, fire, flood"],
  ["Data movement", "Never automatic. You configure it.", "Many services replicate across AZs for you"],
  ["Cross-traffic", "Charged, and higher", "Charged per GB - the classic surprise bill"],
  ["Naming", "ap-south-1", "ap-south-1a (name) / aps1-az1 (ID)"],
  ["Compliance", "Decides which country holds your data", "No residency impact - all one country"],
  ["Your decision", "Where do users and the regulator live?", "How many do I spread across? Answer: 2+"],
];

const EDGES = [
  ["Edge Location", "A small AWS site that caches content and terminates connections near users.", "CloudFront caching, Route 53 answers, Global Accelerator entry.", "The local kirana shop - small stock, two minutes away."],
  ["Regional Edge Cache", "A larger cache sitting between edge locations and your origin.", "Holds less-popular content that small edges would evict.", "The neighbourhood hub the kirana shop restocks from."],
  ["Local Zone", "An extension of a Region inside a metro, running a subset of services.", "Single-digit-ms latency for gaming, media, real-time apps.", "A branch of the Mumbai warehouse, opened in Delhi."],
  ["Wavelength Zone", "AWS compute embedded inside a telecom provider's 5G network.", "Traffic never leaves the mobile network to reach your app.", "A shop inside the mobile tower itself."],
  ["Outpost", "A rack of AWS hardware installed in your own data centre.", "Data that legally cannot leave your building.", "AWS ships you the warehouse."],
];

const ARNS = [
  ["arn:aws:s3:::braincloud-lessons/phase1/regions.md", "S3 object. Region and account are EMPTY - a bucket name is globally unique, so AWS does not need them to find it."],
  ["arn:aws:iam::123456789012:user/sa", "IAM user. No Region, because IAM is global. Account ID present, because identities belong to one account."],
  ["arn:aws:ec2:ap-south-1:123456789012:instance/i-0abc123def4567890", "EC2 instance. Fully qualified - service, Region, account, resource type, resource ID. The shape you will see most."],
  ["arn:aws:dynamodb:ap-south-1:123456789012:table/Orders", "DynamoDB table. Same shape, with resource-type/resource-id split by a slash."],
  ["arn:aws-cn:ec2:cn-north-1:123456789012:instance/i-0abc", "Partition is aws-cn. China is a separate partition run by a local partner. GovCloud uses aws-us-gov."],
];

const CATS = [
  ["Compute", "Run code and servers", ["EC2 - virtual machines", "Lambda - run a function, no server", "ECS / EKS - run containers", "Fargate - containers, no servers to manage"]],
  ["Storage", "Keep data at rest", ["S3 - object storage for files", "EBS - a disk attached to one EC2", "EFS - a shared file system", "Glacier - cheap long-term archive"]],
  ["Database", "Structured data with queries", ["RDS - managed MySQL / PostgreSQL", "Aurora - AWS's faster RDS engine", "DynamoDB - managed NoSQL", "ElastiCache - in-memory cache"]],
  ["Networking & CDN", "Connect things, deliver fast", ["VPC - your private network", "Route 53 - DNS", "CloudFront - CDN", "ELB - load balancers"]],
  ["Security & Identity", "Who can do what", ["IAM - users, roles, permissions", "KMS - encryption keys", "Secrets Manager - store passwords", "WAF / Shield - block attacks"]],
  ["Management", "Watch it and control it", ["CloudWatch - metrics, logs, alarms", "CloudTrail - who called which API", "AWS Config - how did this change", "Systems Manager - operate fleets"]],
];

const RAPID = [
  "In one sentence: what is the difference between a Region and an Availability Zone?",
  "Why does an Availability Zone contain more than one data centre?",
  "Name two AWS services that are global rather than Regional.",
  "Your EBS volume is in ap-south-1b. Can you attach it to an EC2 in ap-south-1c? Why?",
  "In arn:aws:s3:::my-bucket/report.pdf, why are two fields empty?",
];

const PROG = [
  ["What AWS is", 1], ["Global Infrastructure", 1], ["Regions", 1], ["Availability Zones", 1],
  ["Edge Locations", 1], ["AWS Account", 1], ["Management Console", 1], ["AWS CLI", 1],
  ["ARN", 1], ["Service categories", 1], ["Phase 2 - EC2 & Compute", 0], ["Phase 3 - Networking / VPC", 0],
];

const TABS = [
  ["why", "01 · Why"], ["map", "02 · Region → AZ → DC"], ["vs", "03 · Region vs AZ"],
  ["edge", "04 · Edge network"], ["arn", "05 · Account · CLI · ARN"], ["svc", "06 · Service map"],
  ["lab", "07 · Hands-on"], ["brk", "08 · Break it"], ["quiz", "09 · Quiz"], ["rev", "10 · Revision"],
];

const FAILS = [
  {
    t: "The 'Multi-AZ' deployment that isn't",
    d: `        Region: ap-south-1 (Mumbai)
+------------------------------------------+
|  AZ ap-south-1a                          |
|    EC2-web-1   EC2-web-2   EC2-web-3     |
|    RDS-primary                           |
+------------------------------------------+
|  AZ ap-south-1b       (empty)            |
+------------------------------------------+
|  AZ ap-south-1c       (empty)            |
+------------------------------------------+

Team says: "Three servers - we are highly available."`,
    q: "Three servers, one Region. Why is this NOT highly available?",
    a: [
      "All three share one failure domain. The AZ is the blast radius - one set of power, cooling and facilities. Lose ap-south-1a and the web tier and database go together.",
      "Three copies in one AZ protect against ONE instance failing (bad host, crashed OS). They do not protect against the AZ failing.",
      "Fix: spread across at least two AZs, put a load balancer in front, enable RDS Multi-AZ so the standby sits in a different AZ.",
      "Exam phrasing: 'survive the loss of a data centre' = 2+ AZs. 'Survive the loss of a Region' = 2+ Regions.",
    ],
  },
  {
    t: "The compliant architecture that broke the law",
    d: `Indian bank, data-localisation requirement:
"All payment data must be stored inside India."

  S3 bucket (ap-south-1 / Mumbai)
        |
        |  Cross-Region Replication enabled
        |  "for better availability"
        v
  S3 bucket (us-east-1 / N. Virginia)`,
    q: "Availability went up. What went wrong anyway?",
    a: [
      "A copy of the data now sits physically on disks in the United States. The rule was not 'keep a copy in India' - it was 'keep the data inside India'.",
      "Build this habit early: availability and compliance are different requirements, and improving one can break the other.",
      "Correct design: replicate to a second Indian Region (ap-south-2 / Hyderabad), or stay in one Region and rely on versioning plus the cross-AZ durability S3 Standard already gives you.",
      "Exam signal: when a question names a country, a regulator, or says 'data must not leave', your Region choice is the answer - not the storage class.",
    ],
  },
  {
    t: "Two accounts, same AZ letter, different building",
    d: `Account A                    Account B
 subnet ap-south-1a    <-->    subnet ap-south-1a
      |                             |
      v                             v
 physical AZ aps1-az2          physical AZ aps1-az3

Both teams: "We're in 1a, so traffic stays in one AZ."
Reality: every packet crosses a zone boundary.`,
    q: "Both said ap-south-1a. Why are they in different physical zones?",
    a: [
      "AZ NAMES are randomised per account. Your ap-south-1a and mine are usually different physical zones - AWS does this so customers don't all pile into the letter 'a'.",
      "AZ IDs (aps1-az1, aps1-az2 ...) are stable and identical across every account. Two accounts are truly co-located only when the AZ ID matches.",
      "The cost of missing it: unbudgeted cross-AZ data transfer charges, plus latency you cannot explain.",
      "Check with: aws ec2 describe-availability-zones --region ap-south-1 --query 'AvailabilityZones[].[ZoneName,ZoneId]' --output table",
    ],
  },
  {
    t: "The CLI that sees nothing",
    d: `$ aws s3 ls
2026-03-11 09:14:22 braincloud-lessons      <- works

$ aws ec2 describe-instances
{ "Reservations": [] }                      <- empty!

(The console clearly shows 4 running instances.)`,
    q: "S3 works, EC2 returns nothing. What is going on?",
    a: [
      "The CLI default Region is not the Region holding your instances. EC2 is Regional - describe-instances answers for one Region and returns an empty list rather than an error.",
      "aws s3 ls still worked because listing buckets is a global-namespace operation, which hid the problem.",
      "Diagnose: aws configure list - it shows the effective Region and where the value came from.",
      "Fix: aws configure set region ap-south-1, or pass --region on the command.",
      "Related trap: a new account cannot see opt-in Regions such as ap-south-2 at all until you enable them in Account settings.",
    ],
  },
];

const QUIZ = [
  {
    q: "A Delhi startup is launching a web app whose users are all in India. Where should the workload run to minimise latency?",
    o: ["us-east-1, because AWS ships new services there first", "ap-south-1 (Mumbai), the Region closest to the users", "A CloudFront distribution only, with no Region chosen", "Whichever Region is cheapest - latency is the same everywhere"],
    a: 1,
    w: "Latency follows physical distance and network path. Mumbai is nearest to Indian users.",
    x: ["Service freshness doesn't outweigh ~200 ms of extra round trip on every request.", null, "CloudFront caches at the edge, but it still needs an origin - and the origin lives in a Region.", "Region prices do differ, but latency is not uniform. You can't buy your way out of the speed of light."],
  },
  {
    q: "An app must survive the complete loss of one data centre with no downtime, but must stay in a single Region. Minimum design?",
    o: ["Two EC2 instances in the same AZ behind a load balancer", "One large EC2 instance with automated snapshots", "EC2 instances in at least two AZs behind a load balancer", "Two Regions with cross-Region replication"],
    a: 2,
    w: "The AZ is the failure boundary for a data centre event. Spreading across 2+ AZs behind a load balancer keeps you serving when one AZ goes dark.",
    x: ["Both instances share that AZ's power and cooling. One event takes out both.", "Snapshots are a recovery tool, not an availability tool - you'd be down during the restore.", null, "That exceeds the requirement and breaks the 'single Region' constraint, at much higher cost."],
  },
  {
    q: "Which of these is pinned to exactly one Availability Zone?",
    o: ["A VPC", "An EBS volume", "An IAM role", "An S3 bucket"],
    a: 1,
    w: "EBS is zonal. A volume attaches only to an instance in the same AZ; to move it you snapshot and recreate elsewhere.",
    x: ["A VPC is Regional - it spans every AZ in its Region.", null, "IAM is global. One role works from any Region.", "An S3 bucket is Regional, and S3 already spreads objects across AZs for you."],
  },
  {
    q: "A public-sector customer says citizen records must be stored and processed only within India. Which design satisfies this?",
    o: ["ap-south-1 replicating to ap-southeast-1 (Singapore) for DR", "us-east-1 with a customer-managed KMS key", "ap-south-1 for production, replicating to ap-south-2 (Hyderabad) for DR", "ap-south-1 with CloudFront enabled globally for speed"],
    a: 2,
    w: "Mumbai and Hyderabad are both inside India, so data never leaves the country while you still get Region-level DR.",
    x: ["Singapore is outside India. A replicated copy is still storage - the rule is broken.", "Encryption protects confidentiality, not location. The bytes are still on US soil.", null, "CloudFront caches at edges worldwide, which can place data outside India. Caching and encryption are separate concerns from residency."],
  },
  {
    q: "Two AWS accounts each deploy into 'ap-south-1a'. What can you conclude about physical placement?",
    o: ["They are in the same physical Availability Zone", "Nothing - AZ names are randomised per account; compare AZ IDs", "They are guaranteed to be in different zones", "They are in the same data centre building"],
    a: 1,
    w: "AZ names are mapped independently per account. Only the AZ ID (e.g. aps1-az1) is consistent across accounts.",
    x: ["Very likely false. The letter is an account-specific alias, not a physical address.", null, "Not guaranteed either - they might coincidentally match. The point is you can't tell from the name.", "An AZ is one or more data centres, so even matching AZs doesn't mean one building."],
  },
  {
    q: "Reading arn:aws:iam::123456789012:role/BackupRole - why is the Region field empty?",
    o: ["The ARN is malformed and will be rejected", "IAM is a global service, so its resources aren't tied to a Region", "The role hasn't been assigned to a Region yet", "Roles inherit the Region of whoever assumes them"],
    a: 1,
    w: "Global services (IAM, Route 53, CloudFront, Organizations) omit the Region segment because the resource exists account-wide.",
    x: ["Empty segments are valid and meaningful ARN syntax - note the double colon.", null, "There is no such assignment step. IAM identities have no Region concept.", "The role doesn't change identity based on caller. Its scope is the account."],
  },
  {
    q: "A new engineer runs aws ec2 describe-instances and gets an empty list, but the console shows 6 running instances. Most likely cause?",
    o: ["The IAM user lacks ec2:DescribeInstances permission", "The CLI is pointed at a different Region than the instances", "The instances are stopped", "EC2 requires --all-regions by default"],
    a: 1,
    w: "EC2 is Regional and returns an empty result set - not an error - when a Region has no matching resources. Check aws configure list.",
    x: ["A permissions problem returns an explicit AccessDenied error, not empty results. Worth memorising that distinction.", null, "Stopped instances still appear, with state 'stopped'.", "No such default. describe-regions has --all-regions; describe-instances does not."],
  },
  {
    q: "Which statement about AWS Regions is correct?",
    o: ["Data is automatically replicated between Regions for durability", "Regions are connected by the public internet only", "Regions are isolated; you must explicitly configure cross-Region data movement", "Every AWS service is available in every Region on launch day"],
    a: 2,
    w: "Region isolation is deliberate. It contains failures and enables data residency - but it means replication is always opt-in.",
    x: ["The most common beginner assumption, and false. Nothing crosses a Region boundary unless you configure it.", "AWS runs its own redundant private backbone between Regions.", null, "Service availability varies by Region. Check the Region table before designing."],
  },
];

function Hd({ step, title, sub }) {
  return (
    <div className="hd">
      <div className="step">{step}</div>
      <div>
        <h2>{title}</h2>
        {sub ? <p>{sub}</p> : null}
      </div>
    </div>
  );
}

function Co({ kind, title, children }) {
  return (
    <div className={"co " + kind}>
      <h5>{title}</h5>
      <div>{children}</div>
    </div>
  );
}

function Explorer() {
  const [rc, setRc] = useState("ap-south-1");
  const [an, setAn] = useState("ap-south-1a");
  const r = REGIONS.find((x) => x.code === rc);
  const a = r.azs.find((z) => z[0] === an) || r.azs[0];

  return (
    <div className="exp">
      <div>
        <div className="lbl">Level 1 — Region</div>
        <p className="hint">A geographic area. Pick one.</p>
        {REGIONS.map((x) => (
          <button
            key={x.code}
            className={"node" + (x.code === rc ? " on" : "")}
            onClick={() => { setRc(x.code); setAn(x.azs[0][0]); }}
          >
            <span className="c">{x.code}</span>
            <span className="t">
              {x.city}
              {x.home ? <em className="flag">closest to you</em> : null}
              {x.optIn ? <em className="flag w">opt-in</em> : null}
            </span>
          </button>
        ))}
      </div>
      <div>
        <div className="lbl">Level 2 — Availability Zone</div>
        <p className="hint">Isolated zones inside {r.city}. Minimum three per Region.</p>
        {r.azs.map((z) => (
          <button key={z[1]} className={"node" + (z[0] === a[0] ? " on" : "")} onClick={() => setAn(z[0])}>
            <span className="c">{z[0]}</span>
            <span className="t">AZ ID <b>{z[1]}</b></span>
          </button>
        ))}
        <div className="micro">
          Names shuffle per account. IDs never do. Two accounts are truly co-located only when the <b>AZ ID</b> matches.
        </div>
      </div>
      <div>
        <div className="lbl">Level 3 — Data centres</div>
        <p className="hint">{a[0]} is built from {a[2]} discrete facilit{a[2] > 1 ? "ies" : "y"}.</p>
        <div className="dcs">
          {Array.from({ length: a[2] }).map((_, i) => (
            <div className="dc" key={i}><i /><i /><i /><span>DC-{i + 1}</span></div>
          ))}
        </div>
        <div className="micro">
          Each facility has its own power feed, cooling and physical security. You never choose a data centre — AWS stops exposing detail at the AZ.
        </div>
      </div>
    </div>
  );
}

function Fail({ f, i }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="fail">
      <div className="no">Broken #{i + 1}</div>
      <h3>{f.t}</h3>
      <pre className="ascii">{f.d}</pre>
      <p className="ask">{f.q}</p>
      <button className="btn" onClick={() => setOpen(!open)}>
        {open ? "Hide diagnosis" : "Diagnose it yourself first, then reveal"}
      </button>
      {open ? <ol>{f.a.map((s, j) => <li key={j}>{s}</li>)}</ol> : null}
    </div>
  );
}

function Quiz() {
  const [p, setP] = useState({});
  const keys = Object.keys(p);
  const right = keys.filter((k) => QUIZ[Number(k)].a === p[k]).length;
  return (
    <div>
      <div className="score">
        <div><span className="n">{right}/{QUIZ.length}</span><span className="l">correct</span></div>
        <div className="bar"><div className="fill" style={{ width: (keys.length / QUIZ.length) * 100 + "%" }} /></div>
        <button className="btn ghost" onClick={() => setP({})}>Reset</button>
      </div>
      {QUIZ.map((q, i) => {
        const c = p[i];
        const done = c !== undefined;
        return (
          <div className="q" key={i}>
            <div className="no">Q{i + 1}</div>
            <p className="txt">{q.q}</p>
            <div className="opts">
              {q.o.map((o, j) => {
                let s = "";
                if (done) s = j === q.a ? " right" : j === c ? " wrong" : " dim";
                return (
                  <button key={j} className={"opt" + s} disabled={done} onClick={() => setP({ ...p, [i]: j })}>
                    <span className="k">{String.fromCharCode(65 + j)}</span><span>{o}</span>
                  </button>
                );
              })}
            </div>
            {done ? (
              <div className={"vd" + (c === q.a ? "" : " no")}>
                <b>{c === q.a ? "Correct." : "Not quite — the answer is " + String.fromCharCode(65 + q.a) + "."}</b> {q.w}
                {c !== q.a && q.x[c] ? (
                  <div className="w"><b>Why {String.fromCharCode(65 + c)} fails: </b>{q.x[c]}</div>
                ) : null}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}

export default function AWSOverview() {
  const [tab, setTab] = useState("why");

  return (
    <div style={{ padding: "24px", minHeight: "100%", overflowY: "auto" }}>
      <div className="bc1">
        <style>{CSS}</style>

        <header className="hero">
          <div className="mono">BrainCloud.ai · AWS Solutions Architect track</div>
          <h1>Phase 1<i>/</i><em>AWS Foundations</em></h1>
          <p className="lede">
            Before you can place a server, you have to answer one question: where on Earth does it live,
            and what happens when that place breaks? Every architecture decision in this course sits on
            top of the answer.
          </p>
          <pre className="ascii">{`   Region  --------------  a geographic area, e.g. Mumbai
      |
      +-- Availability Zone  --  isolated power, cooling, network
      |        |
      |        +-- Data Centre  --  the physical building
      +-- Availability Zone
      +-- Availability Zone

   minimum 3 AZs per Region · 1+ data centres per AZ`}</pre>
          <div className="stats">
            <div><b>39</b><span>Regions worldwide</span></div>
            <div><b>123</b><span>Availability Zones</span></div>
            <div><b>2</b><span>Regions in India</span></div>
            <div><b>3</b><span>minimum AZs per Region</span></div>
          </div>
          <p className="fine">
            Counts as published by AWS in August 2026, with Saudi Arabia and Chile announced. These numbers
            move — check the AWS global infrastructure page before quoting them.
          </p>
        </header>

        <nav className="tabs" aria-label="Lesson sections">
          {TABS.map((t) => (
            <button key={t[0]} className={tab === t[0] ? "on" : ""} onClick={() => setTab(t[0])}>{t[1]}</button>
          ))}
        </nav>

        <main className="body">
          {tab === "why" && (
            <section>
              <Hd step="Why" title="Start with the problem, not the service"
                sub="A payments company in Delhi runs everything from one rented rack in one building." />
              <p className="p">
                For two years it works. Then a transformer in that building fails and the generator does not
                start. For four hours the company is not slow — it is gone. No website, no API, no database,
                and the only backup tape is in the same room.
              </p>
              <p className="p">
                Four separate problems are tangled together in that story, and AWS answers each one at a
                different layer of its infrastructure.
              </p>
              <div className="grid">
                {[
                  ["One building can fail entirely", "Availability Zones", "Independent zones inside one Region, each with its own power and cooling, linked by fast private fibre. Run in two, lose one, stay up."],
                  ["One city can be hit by a disaster", "Regions", "Fully isolated deployments in different geographies. Nothing crosses between them unless you configure it."],
                  ["Distant users see a slow site", "Edge locations", "Hundreds of small sites that cache content near the user instead of dragging every request back to the Region."],
                  ["A regulator says data must stay in India", "Region selection", "You choose the country your bytes sit in. Region choice is a compliance decision, not just a latency one."],
                ].map((x) => (
                  <div className="card" key={x[1]}>
                    <p style={{ color: "var(--ink)", fontWeight: 600 }}>{x[0]}</p>
                    <div className="mono" style={{ color: "var(--fnt)", margin: "10px 0 4px" }}>solved by</div>
                    <h4 style={{ fontFamily: "var(--m)", fontSize: "15px" }}>{x[1]}</h4>
                    <p style={{ margin: "8px 0 0" }}>{x[2]}</p>
                  </div>
                ))}
              </div>
              <Hd step="What" title="So what is AWS, in one paragraph?" />
              <p className="p">
                AWS is Amazon's rented computing. Amazon builds and operates the buildings, power, cooling,
                physical security, servers and network. You rent slices of that through an API, pay for what
                you use, and give it back when you're done. You never see the hardware. What you get instead
                is a set of addresses — Region, then Availability Zone — that tell you where your slice
                physically lives and what it shares its fate with.
              </p>
              <Co kind="key" title="The mental shift">
                In your own data centre, capacity is bought months in advance. On AWS it's requested in
                seconds and released just as fast. Almost every pattern you'll learn — Auto Scaling, Spot,
                serverless, multi-AZ — exists because that one property changed.
              </Co>
            </section>
          )}

          {tab === "map" && (
            <section>
              <Hd step="What" title="Region → Availability Zone → Data Centre"
                sub="Click through the three levels. This hierarchy is the spine of everything that follows." />
              <Co kind="note" title="The analogy that holds up">
                A <b>Region</b> is a city — Mumbai. An <b>Availability Zone</b> is a separate campus in a
                different part of that city, with its own power line, water and security gate, connected to
                the others by a private high-speed road. A <b>data centre</b> is one building on that campus.
                If a campus floods, the others keep working. If the whole city is cut off, you need a second
                city — a second Region.
              </Co>
              <Explorer />
              <Hd step="How" title="What each level actually guarantees" />
              <div className="grid">
                <div className="card">
                  <h4>Region</h4>
                  <p>A named geographic area containing a cluster of AZs, designed with a minimum of three isolated AZs. Regions are <b>isolated from each other by design</b> — no data, traffic or failure crosses a Region boundary unless you build a path.</p>
                  <p className="foot"><span>code shape</span><code>ap-south-1</code> = geography <code>ap</code> · direction <code>south</code> · sequence <code>1</code></p>
                </div>
                <div className="card">
                  <h4>Availability Zone</h4>
                  <p>One or more discrete data centres with redundant power, networking and connectivity, in separate facilities. Far enough apart to avoid one flood or fire, close enough for single-digit-millisecond latency over private fibre — which is exactly what makes synchronous replication (RDS Multi-AZ) practical.</p>
                  <p className="foot"><span>two identifiers</span>name <code>ap-south-1a</code> · ID <code>aps1-az1</code> — the ID is the real one</p>
                </div>
                <div className="card">
                  <h4>Data centre</h4>
                  <p>The physical building — tens of thousands of servers, its own power feed, cooling and security. AWS deliberately does not expose this level. Your smallest addressable unit of physical placement is the AZ, and that is the level your architecture must reason about.</p>
                </div>
              </div>
              <Hd step="Architecture" title="A real Indian deployment" />
              <pre className="ascii">{`                    Users across India
                            |
                            v
             +-----------------------------+
             | Region: ap-south-1 (Mumbai) |
             |  +-----------------------+  |
             |  | AZ ap-south-1a        |  |
             |  |   EC2-web-1           |  |
             |  |   RDS primary         |  |
             |  +-----------------------+  |
             |          ^  private fibre   |
             |          v  ~1 ms           |
             |  +-----------------------+  |
             |  | AZ ap-south-1b        |  |
             |  |   EC2-web-2           |  |
             |  |   RDS standby         |  |
             |  +-----------------------+  |
             |  +-----------------------+  |
             |  | AZ ap-south-1c        |  |
             |  |   spare capacity      |  |
             |  +-----------------------+  |
             +-----------------------------+
                            :
                (optional, Region-level DR)
                            :
             +-----------------------------+
             | ap-south-2 (Hyderabad)      |
             | - still inside India        |
             +-----------------------------+`}</pre>
              <p className="p">
                Read it top down. Users hit Mumbai because it's nearest. The web tier is duplicated across two
                AZs, so losing one campus costs capacity, not availability. The database standby sits in the
                other AZ, synced over that ~1 ms link. And if Mumbai were ever lost entirely, Hyderabad is the
                fallback that still satisfies an Indian residency requirement — which Singapore would not.
              </p>
            </section>
          )}

          {tab === "vs" && (
            <section>
              <Hd step="Compare" title="Region vs Availability Zone"
                sub="If you're fuzzy on one distinction in Phase 1, make it this one. Nothing later works without it." />
              <div className="tw">
                <table>
                  <thead><tr><th>Dimension</th><th>Region</th><th>Availability Zone</th></tr></thead>
                  <tbody>{VS.map((r) => (
                    <tr key={r[0]}><td className="k">{r[0]}</td><td>{r[1]}</td><td>{r[2]}</td></tr>
                  ))}</tbody>
                </table>
              </div>
              <Co kind="key" title="One-line rule">
                <span className="rule">AZ = survive a building. Region = survive a country.</span> Pick the
                Region for latency and law; pick the number of AZs for availability.
              </Co>
              <Hd step="How" title="Global, Regional, Zonal — the scope table"
                sub="Every AWS resource lives at exactly one of these three scopes. Exam questions hide here constantly." />
              <div className="tw">
                <table>
                  <thead><tr><th>Scope</th><th>Resource</th><th>What that means in practice</th></tr></thead>
                  <tbody>{SCOPE.map((r, i) => (
                    <tr key={i}>
                      <td><span className={"pill " + r[0]}>{r[1]}</span></td>
                      <td className="k">{r[2]}</td><td>{r[3]}</td>
                    </tr>
                  ))}</tbody>
                </table>
              </div>
              <Co kind="trap" title="Three traps worth memorising now">
                <ul>
                  <li>An <b>S3 bucket name is globally unique</b>, but the bucket and its data are Regional. Global name is not global data.</li>
                  <li>A <b>subnet is always zonal</b> — which is why a VPC spanning three AZs needs at least three subnets.</li>
                  <li>An <b>ACM certificate used by CloudFront must be issued in us-east-1</b>, wherever your origin is, because CloudFront's control plane lives there.</li>
                </ul>
              </Co>
            </section>
          )}

          {tab === "edge" && (
            <section>
              <Hd step="Why" title="Your Region is in Mumbai. Your user is in London."
                sub="Distance is physics. No instance type fixes it." />
              <p className="p">
                London to Mumbai is roughly 7,000 km each way. Even at the speed of light through fibre that's
                well over 100 ms round trip before your application does anything. Load a page with thirty
                assets and the user feels every one of them. The fix isn't a bigger server — it's putting a
                copy of the content closer to the user.
              </p>
              <pre className="ascii">{`  User in London
       |  ~5 ms
       v
  +----------------------+   cache HIT  -> answered here, done
  |  Edge location       |
  |  (London)            |   cache MISS -> ask upstream
  +----------+-----------+
             v
  +----------------------+
  | Regional edge cache  |   bigger cache, fewer of them
  +----------+-----------+
             |  ~110 ms
             v
  +----------------------+
  | Origin: S3 or ALB    |
  | ap-south-1 (Mumbai)  |
  +----------------------+

  The origin is only touched on a miss.`}</pre>
              <Hd step="What" title="The five edge building blocks" />
              <div className="grid">
                {EDGES.map((e) => (
                  <div className="card cool" key={e[0]}>
                    <h4>{e[0]}</h4>
                    <p>{e[1]}</p>
                    <p className="foot"><span>use it for</span>{e[2]}</p>
                    <p className="foot" style={{ fontStyle: "italic", color: "var(--fnt)" }}><span>think of it as</span>{e[3]}</p>
                  </div>
                ))}
              </div>
              <Co kind="trap" title="Where beginners go wrong">
                An edge location is <b>not</b> a mini Region. You can't launch EC2 there, can't put a database
                there, and it holds no permanent copy of anything — it caches, and cached items expire. If a
                question asks you to <b>run compute</b> close to users, the answer is a Local Zone, a
                Wavelength Zone, or Lambda@Edge — never "an edge location".
              </Co>
              <Co kind="note" title="India angle">
                AWS operates Local Zones in Indian metros such as Delhi and Kolkata, tied back to the Mumbai
                Region — EC2 and EBS inside the metro for latency-sensitive workloads, while the Region stays
                the control point. Verify current Local Zone availability on the AWS Local Zones page before
                designing around one.
              </Co>
            </section>
          )}

          {tab === "arn" && (
            <section>
              <Hd step="What" title="The AWS account is a boundary, not a login"
                sub="The most under-appreciated idea in Phase 1." />
              <p className="p">
                An AWS account is three things at once: a billing container, a security boundary, and a
                namespace. Resources in one account are invisible to another unless you deliberately grant
                access. That's why real companies run <b>many</b> accounts — production, development, security
                logs — rather than one giant account with folders.
              </p>
              <pre className="ascii">{`  AWS Organization  (the company)
        |
        +-- Account 111111111111   prod       <- blast radius
        +-- Account 222222222222   dev
        +-- Account 333333333333   security / logs

  Nothing crosses an account boundary by default.
  A mistake in dev cannot delete prod.`}</pre>
              <Co kind="trap" title="Root user">
                The email you signed up with is the <b>root user</b>. It can do anything, including close the
                account, and no policy can restrict it. Turn on MFA, store the credentials safely, then stop
                using it and create an IAM identity for daily work. This one habit prevents the most expensive
                category of AWS incident.
              </Co>
              <Hd step="How" title="Three ways to talk to AWS" sub="Same API underneath, three front doors." />
              <div className="grid">
                <div className="card"><h4>Management Console</h4>
                  <p>The web UI. Best for learning, exploring an unfamiliar service, reading dashboards. Note the Region selector top-right — it silently scopes almost everything you see. Half of all "my resource disappeared" questions are that dropdown.</p></div>
                <div className="card"><h4>AWS CLI</h4>
                  <p>The command line. Best for repeatable work and anything you'll do more than twice. Every console click maps to a CLI call, which maps to an API call — and CloudTrail records it under that API name.</p></div>
                <div className="card"><h4>SDKs and IaC</h4>
                  <p>Libraries (boto3, AWS SDK for Java) for application code, and CloudFormation or Terraform when you want the whole environment described as a file. You'll get here in later phases.</p></div>
              </div>
              <Hd step="What" title="ARN — the address of every AWS resource"
                sub="Amazon Resource Name. You'll read these for the rest of your AWS career." />
              <pre className="ascii">{`arn : partition : service : region : account-id : resource
 |       |          |          |          |            |
 |       |          |          |          |            +- what it is
 |       |          |          |          +- 12-digit account number
 |       |          |          +- ap-south-1, or EMPTY if global
 |       |          +- s3, ec2, iam, dynamodb ...
 |       +- aws | aws-cn | aws-us-gov
 +- always the literal string "arn"`}</pre>
              {ARNS.map((a) => (
                <div className="arn" key={a[0]}><code>{a[0]}</code><p>{a[1]}</p></div>
              ))}
              <Co kind="key" title="Why this matters early">
                IAM policies don't name resources in English — they name them by ARN. When you write your first
                policy in Phase 4, the difference between <code>arn:aws:s3:::my-bucket</code> (the bucket) and{" "}
                <code>arn:aws:s3:::my-bucket/*</code> (the objects inside it) decides whether your permissions
                work at all. Learn to read ARNs now and that lesson is free later.
              </Co>
            </section>
          )}

          {tab === "svc" && (
            <section>
              <Hd step="What" title="The service map"
                sub="AWS has hundreds of services. You need roughly thirty for the Solutions Architect exam, and they group cleanly by the job they do." />
              <p className="p">
                Don't memorise this. Read it once so that when a service name appears later you already know
                which shelf it sits on. The question to ask about any new AWS service is: <b>which problem does
                it solve, and what was the alternative before it existed?</b>
              </p>
              <div className="grid">
                {CATS.map((c) => (
                  <div className="card" key={c[0]}>
                    <h4>{c[0]}</h4>
                    <div className="sub">{c[1]}</div>
                    <ul>{c[2].map((s) => <li key={s}>{s}</li>)}</ul>
                  </div>
                ))}
              </div>
              <Co kind="note" title="How service availability varies">
                Not every service exists in every Region, and new services usually appear in us-east-1 first. A
                design that works in Virginia can be impossible in Hyderabad. Check the AWS Regional services
                list for every service in your architecture before committing — this is a real failure mode,
                not a technicality.
              </Co>
            </section>
          )}

          {tab === "lab" && (
            <section>
              <Hd step="Hands-on" title="Prove the hierarchy with your own account"
                sub="About fifteen minutes. Nothing here costs money." />
              <div className="lab"><div className="n">1</div><div>
                <h4>Confirm who you are</h4>
                <pre className="sh">{`aws sts get-caller-identity`}</pre>
                <p>Returns your account ID, user ID and — importantly — your ARN. Read that ARN against the diagram in section 05. If it fails, your credentials aren't configured: run <code>aws configure</code> first.</p>
              </div></div>
              <div className="lab"><div className="n">2</div><div>
                <h4>See which Regions your account can use</h4>
                <pre className="sh">{`aws ec2 describe-regions --output table

# including ones you have NOT enabled:
aws ec2 describe-regions --all-regions \\
  --query "Regions[].[RegionName,OptInStatus]" --output table`}</pre>
                <p>The second is the interesting one. Regions marked <code>not-opted-in</code> are invisible to every other API call until you enable them in Account settings — which is why a colleague's <code>ap-south-2</code> resources may not appear for you at all.</p>
              </div></div>
              <div className="lab"><div className="n">3</div><div>
                <h4>Reveal the AZ name-to-ID mapping</h4>
                <pre className="sh">{`aws ec2 describe-availability-zones \\
  --region ap-south-1 \\
  --query "AvailabilityZones[].[ZoneName,ZoneId,ZoneType]" \\
  --output table`}</pre>
                <p>Write down what <code>ap-south-1a</code> maps to in your account. If you have a second account, run it there too — the mapping will almost certainly differ. That's the randomisation from section 02, made concrete.</p>
              </div></div>
              <div className="lab"><div className="n">4</div><div>
                <h4>Watch a Regional service behave regionally</h4>
                <pre className="sh">{`aws ec2 describe-vpcs --region ap-south-1 \\
  --query "Vpcs[].[VpcId,CidrBlock,IsDefault]" --output table

aws ec2 describe-vpcs --region eu-west-1 \\
  --query "Vpcs[].[VpcId,CidrBlock,IsDefault]" --output table`}</pre>
                <p>Two different default VPCs, two different VPC IDs, same account. Neither knows the other exists. That's Region isolation you can see rather than take on trust.</p>
              </div></div>
              <div className="lab"><div className="n">5</div><div>
                <h4>Inspect where your CLI thinks it is</h4>
                <pre className="sh">{`aws configure list

aws configure set region ap-south-1`}</pre>
                <p><code>configure list</code> shows the effective value <b>and its source</b> — config file, environment variable, or command-line flag. When a command mysteriously returns nothing, check this before hunting for permissions problems.</p>
              </div></div>
              <Co kind="key" title="Console version of the same lesson">
                Open the Console, note the Region dropdown top-right, then switch to a Region you've never used.
                Your EC2 dashboard is empty. Nothing was deleted — you walked into a different building. Now
                open IAM and switch Regions again: the users stay. That's global versus Regional, demonstrated
                in two clicks.
              </Co>
            </section>
          )}

          {tab === "brk" && (
            <section>
              <Hd step="Failure" title="Four broken designs"
                sub="Diagnose each one before revealing. Say your reasoning out loud — that's the skill the exam actually tests." />
              {FAILS.map((f, i) => <Fail f={f} i={i} key={i} />)}
            </section>
          )}

          {tab === "quiz" && (
            <section>
              <Hd step="Exam" title="Scenario questions"
                sub="SAA-C03 style. Pick an answer for instant feedback, including why the distractors fail." />
              <Quiz />
            </section>
          )}

          {tab === "rev" && (
            <section>
              <Hd step="Revise" title="Five lines to keep" />
              <ol className="five">
                <li>A <b>Region</b> is a geographic area; an <b>AZ</b> is an isolated cluster of data centres inside it; a Region has a minimum of three AZs.</li>
                <li>Regions are <b>isolated by design</b> — nothing replicates between them unless you configure it. That's a feature, and it's what makes data residency possible.</li>
                <li>AZs are close enough for ~1 ms private-fibre latency, which is why cross-AZ replication can be synchronous and cross-Region replication is asynchronous.</li>
                <li>Every resource is <b>global, Regional or zonal</b>. IAM is global, VPC is Regional, EBS and subnets are zonal.</li>
                <li><b>AZ names are per-account aliases; AZ IDs are physical.</b> Compare IDs when co-location matters.</li>
              </ol>
              <Co kind="key" title="Memory rule">
                <span className="rule">Region = country and law · AZ = building and uptime · Edge = distance and speed</span>
              </Co>
              <Hd step="Test" title="Five rapid-fire questions" sub="No answers here — post yours in the chat and I'll mark them." />
              <ol className="rapid">{RAPID.map((q) => <li key={q}>{q}</li>)}</ol>
              <Hd step="Level 5" title="Architecture question" />
              <div className="task">
                <p>An Indian e-commerce company serves customers across India and a growing base in the UAE. Order data is subject to Indian localisation rules. The site must stay up if a single data centre fails, and product images must load quickly for UAE users.</p>
                <p><b>Which Region, how many AZs, and what goes at the edge? Justify each decision separately.</b></p>
              </div>
              <Hd step="Level 4" title="Troubleshooting question" />
              <div className="task">
                <pre className="ascii">{`Engineer A launches an EC2 instance and attaches
an EBS volume. Works fine.

Engineer B tries to attach that SAME volume to a
second instance for a batch job.

Error: volume is not in the same availability zone
as the instance.

Both instances are in ap-south-1, same account.`}</pre>
                <p><b>Why did it fail, and what are two different ways to fix it?</b></p>
              </div>
              <Hd step="Level 6" title="Exam question" />
              <div className="task">
                <p>A media company runs a workload in ap-south-1 across three AZs. Monthly bills show a large and growing "data transfer" line item. The application is a fleet of EC2 workers reading from a single EBS-backed NFS server, and the Auto Scaling group spreads instances evenly across all three AZs.</p>
                <p><b>Where is the cost coming from, and how would you reduce it without dropping below two AZs of availability?</b></p>
              </div>
              <Hd step="Track" title="Progress" />
              <div className="prog">
                {PROG.map((r) => (
                  <div className={r[1] ? "d" : ""} key={r[0]}><i>{r[1] ? "✓" : " "}</i>{r[0]}</div>
                ))}
              </div>
              <div className="lvl">
                Phase 1 self-assessment ladder: <b>Beginner → Developing → Comfortable → Strong</b>. You're
                ready for Phase 2 when you can explain Region vs AZ to someone else without looking at this
                page, and when the four broken designs in section 08 feel obvious rather than clever.
              </div>
            </section>
          )}
        </main>

        <footer className="ft">
          <span>BrainCloud.ai · AWS SAA-C03 · Phase 1 of 13</span>
          <span>Next: <b>Phase 2 — EC2 and Compute</b></span>
        </footer>
      </div>
    </div>
  );
}
